export default "__VITE_ASSET__B3a2QhY1__"